module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pay-result-confirm"
  }, [(!_vm.paid) ? _c('div', {
    staticClass: "pay-waiting-wrapper"
  }, [_c('img', {
    attrs: {
      "src": ((_vm.$store.state.IMG_HOST) + "loading_icon@2x.png")
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "waiting-content"
  }, [_vm._v("支付结果确认中......")])]) : _c('div', {
    staticClass: "pay-success-wrapper"
  }, [_c('div', {
    staticClass: "left-wrapper"
  }, [_c('img', {
    attrs: {
      "src": ((_vm.$store.state.IMG_HOST) + "pay-success-icon@2x.png")
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "pay-success-text"
  }, [_vm._v("支付成功")])]), _vm._v(" "), _c('div', {
    staticClass: "right-wrapper"
  }, [_c('span', [_vm._v("支付成功！您通过"), _c('b', [_vm._v(_vm._s(_vm.payInstance.payChannelId === 42 ? '支付宝' : '微信支付'))]), _vm._v("￥" + _vm._s(_vm.payInstance.amount))]), _vm._v(" "), _c('span', [_vm._v("订单编号：" + _vm._s(_vm.payInstance.merchantOrderNo))]), _vm._v(" "), _c('span', [_c('b', [_vm._v(_vm._s(_vm.countDown))]), _vm._v("秒后返回到个人中心")]), _vm._v(" "), _c('router-link', {
    staticStyle: {
      "text-decoration": "underline",
      "color": "#fc5832"
    },
    attrs: {
      "to": {
        name: 'taskManagementList'
      }
    }
  }, [_vm._v("立即返回")])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-69692782!./~/vue-loader/lib/selector.js?type=template&index=0!./views/copyrighter/pay/PayResultConfirm.vue
// module id = 1095
// module chunks = 0